import request, { FormDataHeader } from '@/utils/request'
import { GetNoPassCloseReasonItem } from '@/types/close-account'

export function sendSmsCode(params: { phone: string }): Promise<void> {
  return request.post('/api-account/home/sms_code', params, {
    headers: {
      ...FormDataHeader,
      Authorization:
        ' Basic RjdFM0E0QzUxQ0RBNEMxRTAzQ0E2QzZCMUYwMTIwQTM6YmFjOGZiMWM1MjE3MDRkNDgwNTRjZDZiZTNjZjRmOGI=',
    },
  })
}

export function applyCloseAccount(params: { code: string }): Promise<void> {
  return request.post('/api-account/app/user/cancellationApply', params, {
    headers: FormDataHeader,
  })
}

export function getNoPassCloseReasons(params: {
  apply_guid: string
}): Promise<GetNoPassCloseReasonItem[]> {
  return request.get('/api-account/user/getCancellationNoPassReason', { params })
}

// 放弃注销
export function requestGiveUpCloseAccount(params: { apply_guid: string }): Promise<void> {
  return request.post('/api-account/user/giveUpCancellation', params, {
    headers: FormDataHeader,
  })
}
